module.exports = __webpack_public_path__ + "static/media/tf.1129c04b.svg";